import React from "react"

// Função para destacar o texto com base no filtro
const highlightText = (text, filter) => {
  if (!filter) return text
  const regex = new RegExp(`(${filter})`, "gi")
  return text.split(regex).map((part, index) =>
    regex.test(part) ? (
      <span
        key={index}
        style={{
          backgroundColor: "#ff0",
          color: "#000",
          fontWeight: "bold",
          padding: "0 2px",
        }}
      >
        {part}
      </span>
    ) : (
      part
    )
  )
}

const DetailsModalContent = ({ data, filterText }) => {
  return (
    <div style={{ fontFamily: "Arial, sans-serif" }}>
      <label>
        <strong>Data de Publicação: </strong>
        {new Date(data.DataPublicacao).toLocaleDateString()}
      </label>
      <br />
      <label>
        <strong>Código Único da Publicação:</strong> {data.codUnicoPublicacao}
      </label>
      <br />
      <label>
        <strong>Estado:</strong> {data.nomeEstado}
      </label>
      <br />
      <label>
        <strong>Diário:</strong> {data.nomeDiario}
      </label>
      <br />
      <label>
        <strong>Comarca:</strong> {data.nomeComarca}
      </label>
      <br />
      <label>
        <strong>Órgão:</strong> {data.nomeOrgao}
      </label>
      <br />
      <label>
        <strong>Órgão Completo:</strong> {data.orgaoCompleto}
      </label>
      <br />
      <label>
        <strong>Conteúdo: </strong>
        {highlightText(data.conteudo || "N/A", filterText)}
      </label>
      <br />
      <label>
        <strong>Conteúdo Complementar:</strong>{" "}
        {data.conteudoComplementar || "N/A"}
      </label>
      <br />
    </div>
  )
}

export default DetailsModalContent
